import { useLOAReimbursementContext } from "../../../Contexts/LOAReimbursementContext";
import { useLoaConsultContext } from "../../../Contexts/LoaConsultContext";
import ErrorComponent from "../../../Components/ErrorComponent";
import { CircularProgress } from "@mui/material";

function Policies() {
  const {
    formData,
    setFormData,
  } = useLoaConsultContext();

  const { getPolicy, loaPolicies, policyLoadState } = useLOAReimbursementContext();

  const handlePolicyChange = (value) => {
    let newForm = {
      ...formData,
      selectedPolicy: value
    };
    setFormData(newForm);
  };

  const checkPolicyDisabled=(user)=>{
    let isDisabled = false;
    if(user.corpName?.toLowerCase() === "individual" && user.corpCode === "10000"
      && (user.plan?.planDescription?.toLowerCase().includes("prima")
      || user.plan?.planDescription?.toLowerCase().includes("eready"))
    ){
      isDisabled = true;
    }
    return isDisabled;
  }

  const getPolicyClassName=(user)=>{
    let className = "w-full mt-3 border rounded-lg p-3 text-left";
    if(user.cardNo === formData.selectedPolicy?.cardNo){
      className = className + " border-[#0947ab] bg-[#e7eefa]"
    }
    if(checkPolicyDisabled(user)){
      className = className + " opacity-50 bg-[#eeeeee]"
    }
    return className;
  }

  let content = null;
  if (policyLoadState === "load") {
    content = (
      <div className="w-full flex justify-center items-center p-3">
        <CircularProgress />
      </div>
    );
  } else if (["ISE", "timeout", "retry"].includes(policyLoadState)) {
    content = (
      <ErrorComponent
        onRetry={() => getPolicy("retry")}
        isLoading={policyLoadState === "retry"}
      />
    );
  } else {
    content = loaPolicies.map((user) => (
      <button
        key={user.cardNo}
        disabled={checkPolicyDisabled(user)}
        className={getPolicyClassName(user)}
        onClick={() => handlePolicyChange(user)}
      >
        <div className="text-sm">
          <div className="font-bold">{user.plan.planType}</div>
          <div className="pt-1">{`${user.firstName} ${user.middleName} ${user.lastName} ${user.suffixName}`}</div>
        </div>
      </button>
    ));
  }

  return (
    <div className="p-4">
      <p className="text-[#60656D] mb-4">
        Who is this consultation LOA request for?
      </p>
      {content}
    </div>
  );
}

export default Policies;